var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashbackLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41116_52329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.096 184.083V239.014",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.566 211.553H126.636",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4438 0.986328V26.385",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1382 13.6907H70.7396",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.62 100.431C129.694 85.4776 99.2354 93.4276 103.171 108.43C107.107 123.433 138.976 109.554 143.089 125.228C147.202 140.901 113.863 149.157 109.868 133.947",
    stroke: "#001B47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.307 83.2483L116.822 92.8258",
    stroke: "#001B47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.517 141.167L132.032 150.745",
    stroke: "#001B47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8333 73.0002C31.0191 69.5085 23.9864 60.1381 23.9864 49.1304C23.9864 35.1439 35.3294 23.8008 49.316 23.8008C59.6431 23.8008 68.5302 29.9852 72.4756 38.8526",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.492 194.421C211.351 194.421 215.29 190.481 215.29 185.622C215.29 180.763 211.351 176.824 206.492 176.824C201.633 176.824 197.693 180.763 197.693 185.622C197.693 190.481 201.633 194.421 206.492 194.421Z",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5989 138.159C30.9204 93.6643 57.5224 48.1144 102.017 36.436C141.363 26.1088 181.527 45.7077 198.374 81.1573",
    stroke: "#001B47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.322 197.577C104.424 208.052 63.6872 187.753 47.2742 151.366",
    stroke: "#001B47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.74 95.854C213.87 134.44 195.208 173.816 161.06 191.205",
    stroke: "#001B47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.306 75.2391L198.423 81.3446L202.379 65.3953",
    stroke: "#001B47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3912 157.274L47.2643 151.169L43.3091 167.118",
    stroke: "#001B47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.115 167.118C151.082 167.118 173.755 144.446 173.755 116.479C173.755 88.5112 151.082 65.8391 123.115 65.8391C95.1477 65.8391 72.4756 88.5112 72.4756 116.479C72.4756 144.446 95.1477 167.118 123.115 167.118Z",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41116_52329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193.276,
    height: 240,
    fill: "white",
    transform: "translate(23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashbackLight);
export default __webpack_public_path__ + "static/media/Cashback-Light.d137577c6ee90d9a72362620c06eb828.svg";
export { ForwardRef as ReactComponent };